{
  "recordingDashboard": {
    "title": "Recording Cockpit",
    "subtitle": "Track the recording progress of all processes and resolve open assignments.",
    "progress": {
      "title": "Recording Progress ({{count}} processes)",
      "completed": "Completed",
      "inRecording": "In Recording",
      "recordingComplete": "Recorded",
      "notStarted": "Not Started",
      "pendingAssignment": "Pending"
    },
    "tabs": {
      "notStarted": "Not Started",
      "inRecording": "In Recording",
      "completed": "Completed"
    },
    "notStarted": {
      "startRecording": "Start Recording",
      "overdue": "Overdue",
      "noProcesses": "All processes have been started."
    },
    "inRecording": {
      "reassign": "Reassign",
      "noProcesses": "No processes are currently being recorded.",
      "pendingStep": "Pending Assignment",
      "openStep": "Open Step"
    },
    "completed": {
      "noProcesses": "No completed processes yet."
    },
    "surveys": {
      "pending": "Pending",
      "completed": "Completed",
      "dismissed": "Does not perform"
    },
    "actions": {
      "openProcess": "Open process",
      "toggleDetails": "Toggle details"
    },
    "columns": {
      "process": "Process",
      "owner": "Owner",
      "status": "Status",
      "statusRecording": "Recording Status",
      "step": "Step",
      "actions": "Actions",
      "unassigned": "Unassigned",
      "dueDate": "Due Date",
      "type": "Type",
      "assignee": "Assignee"
    },
    "subTable": {
      "step": "Step",
      "survey": "Survey",
      "hideCompleted": "Hide completed",
      "assignment": "Assignment",
      "cannotNudgeNonPerson": "You can only nudge people."
    },
    "status": {
      "openAssignments_one": "{{count}} pending assignment",
      "openAssignments_other": "{{count}} pending assignments",
      "inRecordingSteps": "{{count}} steps in recording",
      "pendingSurveys": "{{count}} pending surveys",
      "overdue": "{{count}} overdue",
      "stepsComplete": "{{completed}}/{{total}} steps recorded",
      "stepsTooltip": "Recorded steps / total known steps"
    },
    "nudge": {
      "title": "Send Reminder",
      "description": "Send a reminder to {{name}} about their recording task for {{process}}.",
      "messagePlaceholder": "Add a personal message...",
      "send": "Send Reminder",
      "success": "Reminder sent successfully."
    }
  }
}
